import { GeomapRPCService } from "./geomap/geomapRPCService.js"
import { PointType, PointInfo } from "./geomap/geomapUtil.js"
import { TabAndRouteSelection, TabAndRouteSelectionProps } from "./geomap/tabAndRouteSelection.js";
import { AppMetadata, Helper } from "./core/util/helper.js";
import { HTTPService, createHtppServiceInstance, JsonResultClass } from "./core/util/httpManager.js";
import { MetaDataHelper } from "./core/util/metaDataHelper.js";
import { InGridValidation, ValidatorHelper, ValidatorHelperAPI, ValidatorHelperData } from "./core/util/validatorHelper.js";
import { General } from "../siteManagement/general.js";
import { CommandManager } from "./core/util/commandManager.js";
import { SheetEventType, Sheet } from "../siteManagement/sheet.js";
import { NotificationHelper } from "./core/util/notificationHelper.js";
import { Config } from "./core/config/config.js";
import { EditorBroadcastChannel } from "./core/util/EditorBroadcastChannel.js";
import { UnloadHelper } from "./core/util/pageUnloadHandler.js";
import { Dialog, DialogProps } from "./core/components/dialog.js";
import { FAIcon } from "./core/components/faIcon.js";
import { EventType } from "../siteManagement/eventManager.js";
import { TargetEntityType, PrintQrHelper } from "./core/components/printQrDialog.js";
import IndividualNDataInlineSaveable from "./core/components/individualNDataInline_saveable.js";
import { Entity, Metadata, Saveable } from "./core/components/commonApp.js";
import { StringKeyDictionary } from "./commonInterfaces.js";
import React from "react"
import ReactDOM from "react-dom";
export class AppHelper {
    private _isInitialized = false;
    private _ignoredMembers = ["constructor", "componentWillMount", "componentDidMount", "handleFieldChange", "render"];
    private _context: any;
    private _entity: Entity;
    private _validator: kendo.ui.Validator;
    private _validatorHelperData: ValidatorHelperData;
    private _customMetaData = null; //nur für den Validator...
    private _isNew = false;
    private _actionCallbacks: StringKeyDictionary<any> = {
        afterSavedSuccessfully: () => { }
    };
    private _srService: GeomapRPCService;
    private editedMetadata;
    private selectedElementId;
    private metadataType: string;
    private broadcastChannel: EditorBroadcastChannel = new EditorBroadcastChannel(() => { this.broadcastChannel.sendMetadata(this._entity) },
        (metadata) => {
            if (metadata.metadata) {
                this.editedMetadata = metadata.metadata;
            }
            this.selectedElementId = metadata.selectedElementId; this._context.setState({})
        },
        () => { this._context.setState({}) });
    private _sheetTitle: string = null;
    private _browserTabTitle: string = Helper.getPageTitle();
    private inGridValidations: InGridValidation[] = [];

    isWindow = false;
    entityChanged = false;
    menuContext = {};
    defined = Helper.hasValue;
    unloadHelper: UnloadHelper;
    metaData: Metadata = null;
    individulaFieldsMetaData = {};
    commandManager = CommandManager.create();
    validatorHelper: ValidatorHelperAPI;
    enableHooks = false;
    sheetWrapper: Sheet = null;

    updateEntity = (entity: any) => {
        this._isNew = entity?.IsNew;
        this._entity = entity;
    }

    init = (context, customMetaData = null) => {
        var that = this;
        this._context = context;
        this._customMetaData = customMetaData;
        function placeFunction(fName, fBody, fBodyRef, parameters, target) {
            if (that.defined(fBody)) {
                if (that.defined(parameters)) {
                    target[fName] = new Function(parameters.join(","), fBody);
                } else {
                    target[fName] = new Function(fBody);
                }
            } else if (that.defined(fBodyRef)) {
                if (that.defined(parameters)) {
                    let p = parameters.join(",");
                    target[fName] = new Function(p, "window['" + fBodyRef + "'](" + p + ");");
                } else {
                    target[fName] = window[fBodyRef];
                }
            }
        }

        function loadMetaData(metaData: AppMetadata, target = null) {
            if (that.defined(metaData) && that.defined(metaData.additional)) {
                let dest = target || that;
                if (that.defined(metaData.additional.objects)) {
                    for (let i = 0; i < metaData.additional.objects.length; i++) {
                        const variableName = metaData.additional.objects[i].name;
                        const variableParts: Array<string> = metaData.additional.objects[i].name.split(".");
                        if (variableParts.length == 1) {
                            let data = metaData.additional.objects[i].data;
                            if (Array.isArray(data) && metaData.additional.objects[i].type == "kendoTemplate")
                                dest[metaData.additional.objects[i].name] = data.join('');
                            else
                                dest[metaData.additional.objects[i].name] = data;
                        }
                        else { // Variablename mit path abbilden (z.B. references.timesGridOptions)
                            if (!dest[variableParts[0]])
                                dest[variableParts[0]] = {};
                            let path = dest[variableParts[0]];
                            for (let j = 1; j < variableParts.length; j++) {
                                if (j == variableParts.length - 1) {
                                    let data = metaData.additional.objects[i].data;
                                    if (Array.isArray(data) && metaData.additional.objects[i].type == "kendoTemplate")
                                        path[variableParts[j]] = data.join('');
                                    else
                                        path[variableParts[j]] = data;
                                }
                                else {
                                    if (!path[variableParts[j]])
                                        path[variableParts[j]] = {};
                                }
                            }
                        }
                    }
                }
                if (that.defined(metaData.additional.functions)) {
                    for (let i = 0; i < metaData.additional.functions.length; i++) {
                        placeFunction(metaData.additional.functions[i].name, metaData.additional.functions[i].body, metaData.additional.functions[i].bodyRef, metaData.additional.functions[i].parameters, dest);
                    }
                }
            }
        }

        function createHookWrapper(original, before, after) {
            return function () {
                if (that.defined(before)) {
                    before.apply(that._context, arguments);
                }

                original.apply(that._context, arguments);

                if (that.defined(after)) {
                    after.apply(that._context, arguments);
                }
            };
        }

        if (!this._isInitialized) {
            this.updateEntity(this._context.props.entity);

            this.isWindow = this._context.props.isWindow;
            loadMetaData(this._context.props.metadata, this._context);
            this.metaData = this._context.props.metadata;
            //Eine Kopie der Metadaten anlegen, die dann an den Editor übergeben wird.

            if (this._isNew) {
                MetaDataHelper.setDefaultValues(this.metaData, this._entity);
            }

            this.sheetWrapper = General.Sheet.Manager.getTopMostSheet();

            if (Helper.hasValue(this.metaData) && Helper.hasValue(this.metaData.pageTitle) && this.metaData.pageTitle.trim() !== "") {
                this._sheetTitle = this.metaData.pageTitle;
            }
            let browserTitle = this._sheetTitle;
            if (Helper.hasValue(this.metaData) && Helper.hasValue(this.metaData.browserTitle) && this.metaData.browserTitle.trim() !== "") {
                browserTitle = this.metaData.browserTitle;
            }
            this._browserTabTitle = browserTitle;
            if (this._shouldSetBroswerTabTitle()) {
                this.updateBrowserTitle();
            }

            this.createUnloadHelper();

            this._isInitialized = true;

            //hooks
            if (that.enableHooks) {
                const hooks = Config.hooks[this._context.props.context.contextType];
                if (this.defined(hooks)) {
                    if (this.defined(hooks.onBeforeDidMount) || this.defined(hooks.onAfterDidMount)) {
                        if (this.defined(this._context.componentDidMount)) {
                            this._context.componentDidMount = createHookWrapper(this._context.componentDidMount, hooks.onBeforeDidMount, hooks.onAfterDidMount);
                        } else {
                            this._context.componentDidMount = createHookWrapper(function () { }, hooks.onBeforeDidMount, hooks.onAfterDidMount);
                        }
                    }

                    if (this.defined(hooks.onBeforeFieldChanged) || this.defined(hooks.onAfterFieldChanged)) {
                        if (this.defined(this._context.handleFieldChange)) {
                            this._context.handleFieldChange = createHookWrapper(this._context.handleFieldChange, hooks.onBeforeFieldChanged, hooks.onAfterFieldChanged);
                        } else {
                            this._context.handleFieldChange = createHookWrapper(function () { }, hooks.onBeforeFieldChanged, hooks.onAfterFieldChanged);
                        }
                    }
                }
            }
        }
    }

    validate = (additionalRequired?: Array<{ name: string; tabName: string; }>, respectVisibleCondition?: boolean) => {
        const hooks = this.enableHooks ? Config.hooks[this._context.props.context.contextType] : null;
        const beforeValidate = (this.enableHooks && this.defined(hooks) && this.defined(hooks.onBeforeValidate)) ? hooks.onBeforeValidate.bind(this._context)() : true;
        this.entityChanged = false;
        this._context.setState({});
        return beforeValidate
            && this.validatorHelper.validate(additionalRequired, respectVisibleCondition)
            && this.validatorHelper.validateInGrids(this.inGridValidations)
            && (this.enableHooks
                && this.defined(hooks)
                && this.defined(hooks.onAfterValidate) ? hooks.onAfterValidate.bind(this._context)() : true);
    }

    addInGridValidation = (inGridValidations: InGridValidation[]) => {
        this.inGridValidations = this.inGridValidations.concat(inGridValidations);
    }

    handlePostSave = (success: boolean, closeAfterSave = false) => {
        if (this._entity == null)
            return;
        this.entityChanged = false;
        if (success) {
            this.changedFields = {}
            if (Helper.hasValue(this.unloadHelper))
                this.unloadHelper.markEntitySaved();
            if (this._isNew && this._entity.IsNew === false) {
                this._isNew = false;
                if (this.defined(this._context.props.context) && this.defined(this._context.props.context.key1)) {
                    this._context.props.context.keyVal1 = MetaDataHelper.getFieldValue(this._entity, this._context.props.context.key1);
                    if (this.defined(this._context.props.context.key2)) {
                        this._context.props.context.keyVal2 = MetaDataHelper.getFieldValue(this._entity, this._context.props.context.key2);
                    }
                }

            }

            if (this.sheetWrapper != null) {
                this.sheetWrapper.trigger(SheetEventType.SavedSuccessfully, { entity: this._context.props.entity });
                if (closeAfterSave) {
                    this.sheetWrapper.hide();
                }
            } else {
                $(window).trigger("savedSuccessfully", { entity: this._context.props.entity, context: this._context.props.context.contextType });
            }

            if (this._actionCallbacks.afterSavedSuccessfully) {
                this._actionCallbacks.afterSavedSuccessfully();
            }
        }
        General.Events.trigger(EventType.SavedSuccessfully, { entity: this._context.props.entity, context: this._context.props.context.contextType });
        if (!closeAfterSave) {
            this._context.setState({}, () => {
                if (this._shouldSetBroswerTabTitle()) {
                    this.updateBrowserTitle();
                }
                if (!Helper.isNullOrEmpty(this._sheetTitle)) {
                    this.updateSheetTitle();
                }
            });
        }
    }

    handleMenuSelect = (action) => {
        this.evalAction(action);
    }

    setEntityDirtyState = (isDirty: boolean, afterSetStateCallback?: () => void) => {
        if (isDirty) {
            this.entityChanged = true;
            if (this.unloadHelper) {
                this.unloadHelper.markEntityChanged();
            }
        } else {
            this.entityChanged = false;
            if (this.unloadHelper) {
                this.unloadHelper.markEntitySaved();
            }
        }
        this._context.setState({}, afterSetStateCallback);
    }

    private changedFields: any = {};
    handleFieldChange = (field, value, dataItem?: any, afterSetStateCallback?: () => void) => {
        if (this._entity == null)
            return;
        // KT - bei "dynamic"-feldern wird häufiger der model ausgelassen und eigener handleFieldChange geschrieben.
        //    damit man aber für einfachere Fälle kein eigener handleFieldChange schreibt, aktualisieren wir das Feld hier
        //    nur wenn model gesetzt. Wenn der Feldtyp nicht "dynamic" ist und zugleich model leer ist, wollen wir, dass es knallt.
        //    
        if (!(field.model === "" && field.type === "dynamic")) {
            if (field.model.indexOf('[') !== -1) {
                this.evalAction(field.model + "=value", { value: value });
            }
            else {
                MetaDataHelper.setFieldValue(this._entity, field.model, value);
            }
        }

        if (field.model) {
            this.changedFields[field.model] = true;
        }

        this.setEntityDirtyState(true, afterSetStateCallback);

        if (this._shouldSetBroswerTabTitle()) {
            this.updateBrowserTitle();
        }

        if (!Helper.isNullOrEmpty(this._sheetTitle)) {
            this.updateSheetTitle();
        }
    }

    isFieldDirty = (model: string): boolean => {
        return this.changedFields[model];
    }

    handleCreateValidator = (validator: kendo.ui.Validator) => {
        this._validator = validator;
        this._validatorHelperData =
        {
            entity: this._entity,
            validator: this._validator,
            metaData: this._customMetaData || this.metaData,
            individualMetaData: null,
            handleEval: this.evalAction
        };
        this.validatorHelper = ValidatorHelper.create(this._validatorHelperData);
    }

    handleIndividulFieldsMetaDataCreated = (metaData: any) => {
        this.individulaFieldsMetaData = metaData;
        this._validatorHelperData.individualMetaData = this.individulaFieldsMetaData;
    }

    evalAction = (action, prepare = null) => {
        if (typeof action === "boolean") {
            return action;
        }

        const ctx = {
            __internal: {
                appContext: this._context,
                selfContext: this
            },
            setModelValue: (values) => {
                if (ctx.entity.RecordRight.CanWrite) {
                    if (Array.isArray(values)) {
                        values.forEach(v => {
                            ctx.entity[v.prop] = v.val;
                        })
                    } else {
                        ctx.entity[values.prop] = values.val;
                    }

                    if (ctx.__internal.selfContext.unloadHelper) {
                        ctx.__internal.selfContext.setEntityDirtyState(true);
                    }
                    ctx.__internal.appContext.setState({});
                }
            },
            saveEnabled: this.unloadHelper && !this.unloadHelper.isEntitySaved(),
            isWindow: this.isWindow,
            entity: this._entity,
            isMobile: Helper.useMobileGui(),
            isMobileApp: Config.settings.isMobileApp,
            isExternal: Config.user.isExternal,
            openEmail: (isHistory = false) => {
                let itemKey = this._context.props.context.keyVal1;
                if (Helper.hasValue(this._context.props.context.keyVal2) && this._entity != null) {
                    const tmp = Helper.getPropValueCaseInsensitive(this._entity, "isguid");
                    if (!Helper.isNullOrEmpty(tmp)) {
                        itemKey = tmp;
                    }
                }
                const url = "EmailSender/"
                    + (isHistory ? "History" : "New")
                    + "?isWindow=true&type="
                    + this._context.props.context.contextType
                    + "&itemKey="
                    + encodeURIComponent(itemKey);
                if (isHistory) {
                    const sheet = General.Sheet.Manager.createSheetWithUrl(url);
                    sheet.setTitle(isHistory ? Config.translations.emailHistory : Config.translations.email);
                } else {
                    window.open((Config.baseUrl + url), '_blank');
                }


            },
            formatDateString: (stringDate) => {
                if (stringDate) {
                    return kendo.toString(kendo.parseDate(stringDate), 'd');
                }
                return null;
            },
            createReport: async (argObj: QRJsonParams) => {
                let titelText = ""
                let interval_token = null;

                const targetElement = $("<div>");
                $("body").append(targetElement);

                const remove_dialog = (intervalToken: number = null) => {
                    if (Helper.hasValue(intervalToken) && Helper.isNumber(intervalToken)) {
                        window.clearTimeout(intervalToken);
                    }
                    ReactDOM.unmountComponentAtNode(targetElement[0]);
                    targetElement[0].remove();
                }

                const dialogProps: DialogProps = {
                    title: titelText,
                    actions: [
                        {
                            label: Config.translations.ok,
                            action: () => {

                            },
                            primary: true
                        }
                    ],
                    afterClose: () => {
                        remove_dialog(interval_token);
                    },
                    width: 250
                };
                ReactDOM.render(
                    <Dialog {...dialogProps} open={true} title={Config.translations.createReport}>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <FAIcon name="spinner" prefix={"fas"} spins={true} attributes={["spin", "3x"]} style={{ color: "var( --primary-color)" }} />
                            <div style={{ marginTop: "15px", lineHeight: "1.25em" }}>{Helper.getTranslation("Reports.PopUp")}</div>
                        </div>
                    </Dialog >, targetElement[0]);


                let download = this.evalAction(argObj.download);
                let url = "PrintService/GenerateReport";
                url += "?filename=" + encodeURIComponent(this.evalTemplate(argObj.fileName));
                url += "&reportname=" + argObj.reportName;
                if (argObj.withDateTime != undefined)
                    url += "&withdatetime=" + argObj.withDateTime;

                argObj.paramValues.forEach((param, index) => {
                    url += "&paramValues[" + index + "].name=" + param.name + "&paramValues[" + index + "].value=" + this.evalAction(param.value);
                });

                if (download) {
                    const download_result = await HTTPService.get<JsonResultClass>(url);
                    if (download_result.Code === 1) {
                        NotificationHelper.showErrorMessage(Config.translations.qrReportGenerationFailed);
                        remove_dialog();
                    } else {
                        let interval_counter = 0;
                        let continue_download = true;
                        const id = download_result.Data.Jobid;
                        interval_token = setInterval(async () => {
                            if (continue_download) {
                                const result = await createHtppServiceInstance().noBusyIndicator().get<JsonResultClass>(`PrintService/CheckFileCreated?jobId=${id}`);
                                interval_counter += 1;
                                if (result.Data || interval_counter > Config.settings.printJobPollingTimeInSeconds) {
                                    continue_download = false;
                                    let downUrl = "PrintService/DownloadReport?jobId=" + id;
                                    if (Helper.hasValue(argObj.deleteReport)) {
                                        downUrl += "&delete=" + argObj.deleteReport;
                                    }
                                    Helper.openInNewBrowserTab(Config.baseUrl + downUrl);
                                    remove_dialog(interval_token);
                                }
                            }
                        }, 1000);
                    }
                }
                else {
                    const result = await HTTPService.get<JsonResultClass>(url);
                    remove_dialog();
                    if (result.Code === 1) {
                        NotificationHelper.showErrorMessage(Config.translations.qrReportGenerationFailed);
                    }
                }
            },
            addToGeomapRoute: (entityType: string) => {
                let lat = this._entity["Laengegrad"];
                let long = this._entity["Breitegrad"];
                if (!Helper.hasValue(lat) || !Helper.hasValue(long) || (lat === 0 && long === 0)) {
                    NotificationHelper.showErrorMessage(Helper.getTranslation("WebSMS.Geodata.NoCoorinates"));
                    return;
                }

                if (!this._srService) {
                    this._srService = new GeomapRPCService();
                }

                let addPoint = (tab?: string, route?: number) => {
                    this._srService.addPoint({ entityType: PointType[entityType], entity: this._entity } as PointInfo, tab, route).then((result) => {
                        if (result) {
                            NotificationHelper.showInfoMessage(Config.translations.pointAdded);
                        }
                        else {
                            NotificationHelper.showErrorMessage(Config.translations.addPointFailure);
                        }
                    })
                        .fail(() => {
                            NotificationHelper.showErrorMessage(Config.translations.addPointFailure);
                        });
                }

                let prepareToAdd = () => {
                    this._srService.getRouteOrTabCount().then((result) => {
                        if (result === -1) {
                            let idParameterString = getIdParameterString(PointType[entityType], this._entity);
                            if (idParameterString == "") {
                                NotificationHelper.showErrorMessage(Config.translations.addPointFailure);
                                return;
                            }

                            Helper.openInNewBrowserTab(Config.baseUrl + "Directions/AddPointInternal?type=" + entityType.toString() + idParameterString);
                        }
                        else {
                            if (result < 2) {
                                addPoint();
                            }
                            else {
                                const sheet = General.Sheet.Manager.createSheet();
                                sheet.setTitle(Config.translations.tabAndRouteSelection);
                                sheet.show(() => {
                                    sheet.mountContent(TabAndRouteSelection,
                                        {
                                            windowRef: sheet,//geomapTreeView,
                                            onSelect: addPoint
                                        } as TabAndRouteSelectionProps);
                                });
                            }
                        }
                    }, () => {
                        NotificationHelper.showErrorMessage(Config.translations.addPointFailure);
                    });
                }

                let getIdParameterString = (entityType: PointType, object: any) => {
                    let idString: string = "";

                    if (!Helper.hasValue(lat) || !Helper.hasValue(long) || (lat === 0 && long === 0))
                        return idString;

                    switch (entityType) {
                        case PointType.Address:
                            idString = "&ids=" + encodeURIComponent(object["AdrNr"]);
                            break;
                        case PointType.Machine:
                            idString = "&ids=" + encodeURIComponent(object["MaschNr"]);
                            break;
                        case PointType.Resource:
                            idString = "&ids=" + encodeURIComponent(object["Ressnr"]);
                            break;
                        case PointType.Assignment:
                            idString = "&ids=" + encodeURIComponent(object["ProjNr"]) + "&ids=" + object["PIndex"];
                            break;
                        case PointType.Ticket:
                            idString = "&ids=" + encodeURIComponent(object["ProblemNr"]);
                            break;
                    }
                    return idString;
                }

                if (this._srService.isDisconnected()) {
                    this._srService.start().done(() => {
                        prepareToAdd();
                    });
                }
                else {
                    prepareToAdd();
                }
            },
            toggleFollow: (objectType) => {
                if (this._entity == null)
                    return;
                const data: StringKeyDictionary<string> = {
                    objectGuid: Helper.getPropValueCaseInsensitive(this._entity, "Isguid"),
                    objectType: objectType
                };

                HTTPService.get<JsonResultClass>("Event/" + (this._entity.IsWatched ? "Unfollow" : "Follow") + "?", data)
                    .then(result => {
                        if (result.Code === 0) {
                            this._entity.IsWatched = !this._entity.IsWatched;
                            //this._updateFollowButton();
                            this._context.setState({});
                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }
                    });
            },
            openEditor: (metadataType) => {
                this.metadataType = metadataType;
                this.broadcastChannel.openEditorPopup(metadataType);
            },
            isEditorSupported: () => {
                return false //Config.user.isSysAdmin && this.broadcastChannel.isBroadcastChannelSupported();
            },
            isConnectedToEditor: () => {
                return this.broadcastChannel.isConnectedToEditor();
            },
            openPrintDialog: (args: QrDialogJsonParams) => {
                const getDefaultName = (reportName) => {
                    if (!Helper.hasValue(args) || Helper.isNullOrEmpty(args.defaultName)) {
                        const now = new Date();
                        return `${reportName}_${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`;
                    } else {
                        return Helper.processTemplate(args.defaultName, (match) => {
                            switch (match) {
                                case "reportName":
                                    return reportName;
                                default:
                                    return this.tryEvalAction(match);
                            }

                        })
                    }
                }

                let targetEntityType: TargetEntityType;
                const id: string = PrintQrHelper.getId(this._context.props.entity);
                if (Helper.hasValue(args) && !Helper.isNullOrEmpty(args.entityType)) {
                    targetEntityType = PrintQrHelper.getTargetEntityType(args.entityType);
                }
                if (!Helper.hasValue(targetEntityType)) {
                    targetEntityType = PrintQrHelper.getTargetEntityType(this._context.props.context.contextType);
                }
                let message: string = "";
                if (!Helper.hasValue(targetEntityType)) {
                    message = `${this._context.props.context.contextType} could not be assigned a context`;
                    NotificationHelper.showErrorMessage(message);
                    console.error(message);
                } else if (Helper.isNullOrEmpty(id)) {
                    message = `No id could be determined`;
                    NotificationHelper.showErrorMessage(message);
                    console.error(message);
                } else {
                    PrintQrHelper.openDialog(targetEntityType, id, getDefaultName);
                }
            }
        }

        for (let key in this._context) {
            if (this._ignoredMembers.indexOf(key) === -1) {
                ctx[key] = this._context[key];
            }
        }

        if (this.defined(prepare)) {
            for (let key in prepare) {
                ctx[key] = prepare[key];
            }
        }

        const addLine = (to, line) => {
            return to + line + ";\n";
        }

        return (function () {
            let body = "";

            for (let key in ctx) {
                body = addLine(body, "var " + key + " = ctx['" + key + "']");
            }

            body = addLine(body, "return " + action);

            let res = new Function("ctx", body)(ctx);
            return res;
        })();
    }

    //Callback to be executed after the data have been loaded
    /** @param {string} field - The name of the field for which the data has been loaded
     *  @param {*} data - The loaded data
     */
    handleDataLoaded = (field, data) => {
    }

    //NOOP function used as default callback
    noop = () => { }

    //Returns an object containing handlers for the common component props
    getHandlersForProps = (appProps?: any) => {
        let props: any = {
            handleMenuSelect: this.handleMenuSelect,
            handleFieldChange: this.handleFieldChange,
            onChange: this.handleFieldChange,
            enableMenuItem: this.evalAction,
            handleCreateValidator: this.handleCreateValidator,
            handleEval: this.evalAction,
            handleDataLoaded: this.handleDataLoaded,
            handleIsSearchFieldFullObjectModel: this.noop,
            handleIndividulFieldsMetaDataCreated: this.handleIndividulFieldsMetaDataCreated,
            translations: this._context.translations,
            commandManager: this.commandManager,
            actionCallbacks: this._actionCallbacks,
            rightDrawerContainer: this.metaData.rightDrawerContainer ? this.metaData.rightDrawerContainer : null,
            menuEntries: this.metaData.menuDataSource,
            sheetTitle: Helper.hasValue(this._sheetTitle) ? this.evalTemplate(this._sheetTitle) : "",
            showContextReminders: this._context.noReminders !== true && this._entity != null && !this._entity.IsNew && (General.Sheet.Manager.getSheetsCount() === 1 || General.Functions.HistoryState.getCurrentStateSummary().sourceSheetId === this.sheetWrapper.id()),
            showBookmarkBtn: this._context.noBookmark !== true && (General.Sheet.Manager.getSheetsCount() === 1 || General.Functions.HistoryState.getCurrentStateSummary().sourceSheetId === this.sheetWrapper.id()),
        }

        if (this._entity && this.broadcastChannel.isConnectedToEditor() && this.editedMetadata) {
            this.modifyPropsForEditor(props, appProps);
        }
        return props;
    }

    tryEvalAction = (code: string) => {
        try {
            return this.evalAction(code);
        } catch (e) {
            return true;
        }
    }

    isEditorEnabled = () => {
        this.broadcastChannel.isConnectedToEditor();
    }

    createUnloadHelper = () => {
        if (this._entity?.RecordRight?.CanWrite ?? false) {
            this.unloadHelper = this.sheetWrapper.setUpUnloadHelper(this.getLoadedModules());
        }
    }

    public evalTemplate = (template: string) => {
        return Helper.processTemplate(template, this.tryEvalAction)
    }

    public updateBrowserTitle = (title: string = null) => {
        const selected = Helper.hasValue(title) ? title : this._browserTabTitle;
        const parsed = (Helper.hasValue(selected) ? this.evalTemplate(selected) : "");
        const finalTitle = (Helper.hasValue(parsed) && parsed.trim() !== "" ? (parsed + " - ") : "") + Helper.getPageTitle();

        document.title = (finalTitle === Helper.getPageTitle() + " - " + Helper.getPageTitle()) ? Helper.getPageTitle() : finalTitle;
    }

    public updateSheetTitle = (title: string = null) => {
        const selected = Helper.hasValue(title) ? title : this._sheetTitle;
        const parsed = (Helper.hasValue(selected) ? this.evalTemplate(selected) : "");
        this.sheetWrapper.setTitle(parsed);
    }

    private modifyPropsForEditor(props: any, appProps: any) {

        const menuItems = this.editedMetadata.additional.objects.filter(o => o.name == "menuDataSource")[0].data;
        props.menuEntries = menuItems.map(m => { m.show = true; return m; });
        props.metadata = this.editedMetadata;
        props.entity = $.extend({ _editorChannel: this.broadcastChannel.channel }, this._entity);

        this.modifyAdditionalObjectsInContext(this.metadataType, props, appProps);

        for (var t = 0; t < props.metadata.tabs.length; t++) {
            props.metadata.tabs[t].visible = true;
            if (props.metadata.tabs[t]._removed) {
                props.metadata.tabs[t].moduleName = "app/statistics/no_permissions_for_module";
                delete (props.metadata.tabs[t].regions);
            }
            if (props.metadata.tabs[t].regions) {
                for (var r = 0; r < props.metadata.tabs[t].regions.length; r++) {
                    if (props.metadata.tabs[t].regions[r].fields) {
                        props.metadata.tabs[t].regions[r].visible = true;
                        for (var f = 0; f < props.metadata.tabs[t].regions[r].fields.length; f++) {
                            const field = props.metadata.tabs[t].regions[r].fields[f];
                            if (field.guid == this.selectedElementId) {
                                field._selected = true;
                            }
                            else {
                                delete field._selected;
                            }
                            field._visible = field.visible && (field.visibleCondition == null || (field.visibleCondition && this.tryEvalAction(field.visibleCondition)));
                            field.visibleCondition = null;
                            field.visible = true;
                        }
                    }
                }
            }
        }
    }

    private modifyAdditionalObjectsInContext = (metadataType: string, props, appProps) => {
        if (!appProps) {
            return;
        }
        props.context = {};
        $.extend(props.context, appProps.context);

        const lowerMetadataType = metadataType.toLowerCase();
        console.log(lowerMetadataType)
        if (lowerMetadataType == 'procedure') {
            props.rightDrawerContainer = this.getObjectByName(this.editedMetadata.additional.objects, "rightDrawerContainer");
            props.context.historyGrid = this.getObjectByName(this.editedMetadata.additional.objects, "historyGridOptions");
            props.context.materialGrid = this.getObjectByName(this.editedMetadata.additional.objects, "articleGridOptions");
            props.context.allocationsTemplate = this.getObjectByName(this.editedMetadata.additional.objects, "ticketStructureTemplate");
        } else if (lowerMetadataType == 'machine') {
            props.rightDrawerContainer = this.getObjectByName(this.editedMetadata.additional.objects, "rightDrawerContainer");
            props.context.allocationsGrid = this.getObjectByName(this.editedMetadata.additional.objects, "allocationsGridOptions");
        }
    }

    private getObjectByName = (objectArray: any[], name: string): any => {
        const filtered = objectArray.filter((value) => value.name == name);
        if (filtered != null && filtered.length) {
            return filtered[0].data;
        }
    }

    private _shouldSetBroswerTabTitle = () => {
        const sheetData = this.sheetWrapper ? this.sheetWrapper.getExternalData() : null;
        return this._context.setTabTitle && (!sheetData || sheetData.disableTabTitle !== true);
    }


    private module = new IndividualNDataInlineSaveable({
        notifyChange: () => {
            this.setEntityDirtyState(true);
            this._context.setState({});
        }
    });

    private loadedModules: Saveable[] = [this.module];
    public resolveModule = (moduleName: string): Saveable => {
        if (moduleName == "app/core/components/IndividualNDataInlineSavable") {
            return this.module;
        }
    }

    public getLoadedModules = (): Saveable[] => {
        return this.loadedModules;
    }

    public getPropsFromContextByName = (functionName: string): any => {
        if (this._context[functionName]) {
            return this._context[functionName]();
        }
        return null;
    }
}

interface QrDialogJsonParams {
    entityType: string;
    id: string;
    defaultName: string;
}

interface QRJsonParams {
    reportName: string;
    fileName: string;
    download: boolean;
    paramValues?: Array<{ name: string, value: string }>;
    deleteReport?: boolean;
    withDateTime?: boolean;
}